import React, { } from "react"
import { View, Text, Image, Pressable } from "react-native"
import { getImagePath } from "../../services/CommonUtils"
import { getChemistSiteUrl } from "../../services/chemist/chemistSiteUrl"
import { getChemistProfilePicUrl, getStoreMaxDiscount, roundOffRating } from "../../services/chemist/ChemistStoreUtils"
import { HomeDelivery, InStorePickUp, PharmacyCity, PharmacyDiscount } from "./StoreSettingsChips"

import AppStyles from "../../../AppStyles"
import TextStyle from "../../../TextStyle"

export const ChemistStoreCardView = (props) => {
    const pharmacy = props.pharmacy
    const discount = getStoreMaxDiscount(pharmacy?.storeSettings?.discounts).discount
    const profilePicUrl = getChemistProfilePicUrl(pharmacy)
    return (
        <Pressable onPress={() => { getChemistSiteUrl(pharmacy) }} style={[AppStyles.borderView,
        AppStyles.bgWhite, AppStyles.mx16, AppStyles.mt12, AppStyles.p16]} onLongPress={() => { console.log('### long press') }}    >
            <View style={[AppStyles.flexRowSpaceBetween, { alignItems: "flex-start" }]}>
                <View style={[AppStyles.flexRowStart]}>
                    <Image style={{ width: 40, height: 40, borderRadius: 20 }}
                        source={{ uri: profilePicUrl }} />
                    <View style={[AppStyles.ml16, { alignItems: "flex-start" }]}>
                        <Text style={[TextStyle.text16b]}>{pharmacy.pharmacyName}</Text>
                        <View style={[AppStyles.flexRowStart, AppStyles.pt4, { alignItems: "center" }]}>
                            <Image source={{ uri: getImagePath('/images/icons/rating_black.svg'), width: 12, height: 12 }} />
                            <Text style={[TextStyle.text14, { marginLeft: 2 }]}>
                                {roundOffRating(pharmacy['actualRating']) ? roundOffRating(pharmacy['actualRating']) : '--'}</Text>
                        </View>
                    </View>
                </View>
                <Image style={{ width: 16, height: 16 }}
                    source={{ uri: getImagePath('/images/icons/right_chevron_circle_blue.svg') }} />
            </View>
            <View style={[AppStyles.flexRow]}>
                {pharmacy?.city && PharmacyCity(pharmacy.city)}
                {discount && discount > 0 ? PharmacyDiscount(discount) : null}
                {pharmacy?.storeSettings?.isProvidingHomeDelivery === true ?
                    HomeDelivery() : InStorePickUp()}
            </View>
        </Pressable>
    )
}